<div class="sla-dashboard">
  <header class="sla-header">
    <div class="sla-title">
      <p class="eyebrow">Managed Services · {{ data?.client || 'CNB' }}</p>
      <h1>Service Desk Operational Efficiency</h1>
    </div>
    <div class="sla-header-actions">
      <button
        mat-stroked-button
        class="export-button"
        (click)="exportExcel()"
        [disabled]="!data || isFetching || isExporting"
      >
        <mat-icon>download</mat-icon>
        {{ isExporting ? 'Exporting…' : 'Export to Excel' }}
      </button>
      <mat-form-field appearance="outline" class="month-picker">
        <mat-label>Reporting period</mat-label>
        <mat-select [value]="selectedPeriod" (selectionChange)="onPeriodChange($event.value)">
          @for (p of periods; track p.value) {
            <mat-option [value]="p.value">{{ p.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </header>

  @if (isFetching) {
    <div class="sla-skeleton">
      <div class="kpi-row">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '76px',
              'border-radius': '8px',
              background: 'var(--skeleton-background)',
            }"
          ></ngx-skeleton-loader>
        }
      </div>
      @for (i of [1, 2]; track i) {
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ width: '100%', height: '220px', 'border-radius': '8px', background: 'var(--skeleton-background)' }"
        ></ngx-skeleton-loader>
      }
    </div>
  } @else if (errorFetching) {
    <div class="section-error">
      <mat-icon>error_outline</mat-icon>
      <span>Could not load the SLA dashboard.</span>
      <button class="retry-button" (click)="retry()">Retry</button>
    </div>
  } @else if (data) {
    <section class="overall" [class]="'band-' + overallBand">
      <span class="overall-label">Overall % met SLA</span>
      <span class="overall-value">{{ overallPct !== null ? (overallPct | percent: '1.1-1') : '—' }}</span>
    </section>

    <section class="kpi-row">
      <app-stat-tile label="Total tickets" [value]="data.summary.total" />
      <app-stat-tile label="Closed tickets" [value]="data.summary.closed" />
      <app-stat-tile label="Met SLA" [value]="data.summary.met" />
      <app-stat-tile label="Missed SLA" [value]="data.summary.missed" />
      <app-stat-tile label="Met SLA – WIP" [value]="data.summary.metWip" hint="Open, on pace" />
      <app-stat-tile label="Missed SLA – WIP" [value]="data.summary.missedWip" hint="Open, past due" />
    </section>

    <div class="legend-row">
      <app-legend-key />
      <p class="footnote">{{ wipNote }}</p>
    </div>

    <div class="cards">
      <section class="card">
        <h2 class="card-title">SLA by Priority</h2>
        <app-breakdown-table rowHeader="Priority" [rows]="data.byPriority" />
      </section>

      <section class="card">
        <h2 class="card-title">SLA by Work Order Category</h2>
        <app-breakdown-table rowHeader="Category" [rows]="data.byCategory" />
      </section>

      <section class="card wide">
        <h2 class="card-title">SLA by Work Order Type</h2>
        <app-breakdown-table rowHeader="Work order type" [rows]="data.byType" />
      </section>

      <section class="card">
        <h2 class="card-title">SLA % Met by Team and Priority</h2>
        <app-matrix-table rowHeader="Team" [rows]="data.teamPriorityMatrix" />
      </section>

      <section class="card">
        <h2 class="card-title">SLA % Met by Team</h2>
        <app-breakdown-table rowHeader="Team" [rows]="data.byTeam" [showTotal]="false" />
      </section>

      <section class="card">
        <h2 class="card-title">SLA % Met by BU</h2>
        <app-breakdown-table rowHeader="BU" [rows]="data.byBu" [showTotal]="false" />
      </section>

      <section class="card">
        <h2 class="card-title">SLA % Met by BU and Priority</h2>
        <app-matrix-table rowHeader="BU" [rows]="data.buPriorityMatrix" [totalOverall]="data.buPriorityOverallTotal" />
      </section>

      <section class="card wide">
        <h2 class="card-title">SLA % Met by Tech</h2>
        <app-tech-table [rows]="data.byTech" />
      </section>

      <section class="card wide">
        <h2 class="card-title">Top 20 Users by Ticket Volume</h2>
        <app-top-users-table [rows]="data.topUsers" />
      </section>
    </div>
  }
</div>
